import { FunctionComponent } from 'react';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticleSectionHero: FunctionComponent<Props> = ({ override }) => {
    return (
        <StyledComponent className="public-page-article-section-hero">
            <div className="bg-mask" />
            {override()}
        </StyledComponent>
    );
};

export default PublicPageArticleSectionHero;
